export const environment = {
    production: false,
    // apiBaseUrl: 'https://app.irms.cloudns.biz/api',
    //apiBaseUrl: 'http://localhost:8181/api',
    apiBaseUrl: 'https://tajirms.com/irms-app/api',
};
